import { useCurrency } from "@/context/CurrencyContext";

const OPTIONS = [["original", "As listed"], ["NGN", "₦ NGN"], ["USD", "$ USD"], ["GBP", "£ GBP"], ["EUR", "€ EUR"], ["CAD", "C$ CAD"]];

export const CurrencySwitcher = ({ dark = false, testPrefix = "currency" }) => {
  const { currency, setCurrency, rates } = useCurrency();
  if (!rates) return null;
  return (
    <div data-testid={`${testPrefix}-switcher`}>
      <div className={`flex flex-wrap border ${dark ? "border-white/40" : "border-gw-rule/30"}`} role="radiogroup" aria-label="Show prices in">
        {OPTIONS.map(([v, label]) => (
          <button key={v} type="button" role="radio" aria-checked={currency === v} onClick={() => setCurrency(v)} data-testid={`${testPrefix}-${v.toLowerCase()}`}
            className={`lab text-[11px] px-3 py-2 transition-colors duration-200 ${currency === v
              ? dark ? "bg-white text-gw-onwhite" : "bg-gw-btn text-gw-btnfg"
              : dark ? "hover:bg-white/10" : "hover:bg-gw-hover"}`}>
            {label}
          </button>
        ))}
      </div>
      <p className={`text-[10px] mt-1 ${dark ? "text-gw-pale/70" : "opacity-60"}`}>
        Converted prices are estimates. Rates by <a href="https://www.exchangerate-api.com" target="_blank" rel="noopener noreferrer" className="underline">ExchangeRate-API</a>
      </p>
    </div>
  );
};
